const LOGO_EP3D = "https://customer-assets.emergentagent.com/job_89a536dc-36dd-4821-ba4f-a6c069ebdb60/artifacts/u7v2hasx_Logotipo.png";

/**
 * Gera e abre uma janela para impressão da Folha de Embalagem
 * baseada nos dados do endpoint /api/orders/{id}/packing-criteria
 */

const LOGO_URL = "https://customer-assets.emergentagent.com/job_89a536dc-36dd-4821-ba4f-a6c069ebdb60/artifacts/epconstruxx-logo.png";

export function openPackingSlip(data) {
  const { order, part, packaging, order_estimates, client_name, last_weight_verification } = data;
  const now = new Date().toLocaleString("pt-PT");

  const html = `<!DOCTYPE html>
<html lang="pt">
<head>
<meta charset="utf-8" />
<title>Folha de Embalagem - ${order.code || ""} - ${part.code || ""}</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Segoe UI', Arial, sans-serif; color: #1e293b; padding: 18mm 16mm; font-size: 11px; }
  .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 4px solid #f97316; padding-bottom: 10px; margin-bottom: 16px; }
  .brand { display: flex; align-items: center; gap: 12px; }
  .brand-text { line-height: 1.1; }
  .brand-name { font-size: 18px; font-weight: 900; color: #0f172a; letter-spacing: -0.3px; }
  .brand-tag { font-size: 9px; color: #1e40af; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
  .title-block { text-align: right; }
  .title-block h1 { font-size: 18px; color: #f97316; font-weight: 800; letter-spacing: 1px; text-transform: uppercase; }
  .title-block .sub { font-size: 11px; color: #475569; font-weight: 600; margin-top: 2px; }
  .meta { background: #0f172a; color: #fff; padding: 10px 14px; border-radius: 4px; margin-bottom: 14px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; font-size: 10px; }
  .meta div .lbl { color: #f97316; font-size: 8px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; }
  .meta div .val { font-size: 13px; font-weight: 700; margin-top: 2px; }
  .section { margin-top: 14px; }
  .section h2 { background: #0f172a; color: #fff; padding: 6px 10px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.7px; border-left: 4px solid #f97316; }
  table { width: 100%; border-collapse: collapse; margin-top: 4px; font-size: 11px; }
  th, td { padding: 7px 10px; border-bottom: 1px solid #e2e8f0; text-align: left; }
  th { background: #f1f5f9; font-size: 9px; font-weight: 700; text-transform: uppercase; color: #475569; letter-spacing: 0.5px; }
  td.num { text-align: right; font-family: 'Courier New', monospace; font-weight: 600; }
  .grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .card { border: 1px solid #e2e8f0; border-radius: 4px; padding: 10px 12px; }
  .card .lbl { font-size: 8px; color: #94a3b8; text-transform: uppercase; font-weight: 700; }
  .card .val { font-size: 16px; font-weight: 800; color: #0f172a; margin-top: 3px; }
  .card .sub { font-size: 9px; color: #64748b; margin-top: 2px; }
  .highlight { background: #fff7ed; border-left: 4px solid #f97316; padding: 8px 12px; margin-top: 8px; font-size: 10px; }
  .highlight strong { color: #c2410c; }
  .summary { background: #0f172a; color: #fff; padding: 12px 14px; border-radius: 4px; margin-top: 12px; }
  .summary h3 { font-size: 11px; text-transform: uppercase; color: #f97316; letter-spacing: 0.8px; margin-bottom: 8px; }
  .summary-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
  .summary-item .lbl { font-size: 8px; color: #94a3b8; text-transform: uppercase; }
  .summary-item .val { font-size: 18px; font-weight: 800; margin-top: 2px; }
  .footer { margin-top: 20px; text-align: center; font-size: 9px; color: #64748b; border-top: 1px solid #e2e8f0; padding-top: 8px; }
  .ok { color: #16a34a; font-weight: 700; }
  .warn { color: #ea580c; font-weight: 700; }
  .fail { color: #dc2626; font-weight: 700; }
  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .no-print { display: none; }
  }
  .print-btn { position: fixed; top: 10px; right: 10px; background: #f97316; color: #fff; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-weight: 700; }
</style>
</head>
<body>
<button class="print-btn no-print" onclick="window.print()">🖨️ Imprimir</button>

<div class="header">
  <div class="brand">
    <div class="brand-text">
      <div class="brand-name">EPCONSTRUXX</div>
      <div class="brand-tag">Precision in Every Level</div>
    </div>
  </div>
  <div class="title-block">
    <h1>Folha de Embalagem</h1>
    <div class="sub">Critério de Embalagem da Ordem</div>
  </div>
</div>

<div class="meta">
  <div><div class="lbl">Ordem</div><div class="val">${order.code || "-"}</div></div>
  <div><div class="lbl">Peça</div><div class="val">${part.code || "-"}</div></div>
  <div><div class="lbl">Cliente</div><div class="val">${client_name || part.client || "-"}</div></div>
  <div><div class="lbl">Quantidade</div><div class="val">${(order.good_quantity_target || 0).toLocaleString("pt-PT")} un</div></div>
</div>

<div class="section">
  <h2>Informação da Peça</h2>
  <table>
    <tr><th style="width:30%">Descrição</th><td>${part.description || "-"}</td></tr>
    <tr><th>Material</th><td>${part.plastic_type || "-"}</td></tr>
    <tr><th>Peso por peça</th><td><strong>${(part.unit_weight || 0).toFixed(2)} g</strong></td></tr>
    <tr><th>Peso de 10 peças</th><td><strong>${(part.weight_10_pieces || 0).toFixed(2)} g</strong></td></tr>
    <tr><th>Tolerância peso</th><td>± ${(part.weight_tolerance_pct || 5).toFixed(1)} %</td></tr>
    ${part.weight_min || part.weight_max ? `<tr><th>Limites peso</th><td>${part.weight_min || "-"} g  -  ${part.weight_max || "-"} g</td></tr>` : ""}
  </table>
</div>

<div class="section">
  <h2>Critério de Embalagem</h2>
  <table>
    <thead>
      <tr><th>Nível</th><th>Quantidade</th><th>Peso Sem Saco</th><th>Peso Com Saco</th></tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>Saco</strong></td>
        <td class="num">${packaging.units_per_bag} un</td>
        <td class="num">${(packaging.bag_net_weight_g || 0).toFixed(1)} g</td>
        <td class="num"><strong>${(packaging.bag_gross_weight_g || 0).toFixed(1)} g</strong></td>
      </tr>
      <tr>
        <td><strong>Caixa</strong> (${packaging.bags_per_box} sacos)</td>
        <td class="num"><strong>${packaging.units_per_box} un</strong></td>
        <td class="num">${(packaging.box_net_weight_kg || 0).toFixed(3)} kg</td>
        <td class="num"><strong>${(packaging.box_gross_weight_kg || 0).toFixed(3)} kg</strong></td>
      </tr>
      ${packaging.boxes_per_pallet > 0 ? `
      <tr>
        <td><strong>Palete</strong> (${packaging.boxes_per_pallet} caixas)</td>
        <td class="num"><strong>${packaging.units_per_pallet} un</strong></td>
        <td class="num">-</td>
        <td class="num"><strong>${(packaging.pallet_gross_weight_kg || 0).toFixed(2)} kg</strong></td>
      </tr>` : ""}
    </tbody>
  </table>
  ${packaging.box_dimensions ? `<div class="highlight">📐 Dimensões da caixa: <strong>${packaging.box_dimensions}</strong></div>` : ""}
  <div class="highlight">📌 Peso do saco vazio considerado: <strong>${(packaging.empty_bag_weight_g || 0).toFixed(1)} g</strong> (incluído no peso com saco)</div>
</div>

<div class="summary">
  <h3>📦 Estimativa para esta Ordem (${(order.good_quantity_target || 0).toLocaleString("pt-PT")} unidades)</h3>
  <div class="summary-grid">
    <div class="summary-item"><div class="lbl">Sacos</div><div class="val">${(order_estimates.bags || 0).toFixed(1)}</div></div>
    <div class="summary-item"><div class="lbl">Caixas</div><div class="val">${(order_estimates.boxes || 0).toFixed(2)}</div></div>
    <div class="summary-item"><div class="lbl">Paletes</div><div class="val">${order_estimates.pallets > 0 ? order_estimates.pallets.toFixed(2) : "-"}</div></div>
    <div class="summary-item"><div class="lbl">Peso bruto total</div><div class="val">${((order_estimates.boxes || 0) * (packaging.box_gross_weight_kg || 0)).toFixed(1)} kg</div></div>
  </div>
</div>

${last_weight_verification ? `
<div class="section">
  <h2>Última Verificação de Peso (Início de Turno)</h2>
  <table>
    <tr><th style="width:30%">Operador</th><td>${last_weight_verification.operator_name || "-"} | Turno: ${last_weight_verification.shift || "-"}</td></tr>
    <tr><th>Data/Hora</th><td>${new Date(last_weight_verification.recorded_at).toLocaleString("pt-PT")}</td></tr>
    <tr><th>Peso 1 peça (medido)</th><td><strong>${last_weight_verification.weight_1_piece.toFixed(2)} g</strong> (esperado: ${last_weight_verification.expected_1_piece.toFixed(2)} g) - desvio ${last_weight_verification.deviation_1_piece_pct.toFixed(1)}%</td></tr>
    <tr><th>Peso 10 peças (medido)</th><td><strong>${last_weight_verification.weight_10_pieces.toFixed(2)} g</strong> ${last_weight_verification.expected_10_pieces ? `(esperado: ${last_weight_verification.expected_10_pieces.toFixed(2)} g)` : ""} - desvio ${last_weight_verification.deviation_10_pieces_pct?.toFixed(1) || "-"}%</td></tr>
    <tr><th>Estado</th><td><span class="${last_weight_verification.status === 'ok' ? 'ok' : last_weight_verification.status === 'warning' ? 'warn' : 'fail'}">${last_weight_verification.status.toUpperCase()}</span></td></tr>
    ${last_weight_verification.notes ? `<tr><th>Notas</th><td>${last_weight_verification.notes}</td></tr>` : ""}
  </table>
</div>` : `
<div class="section">
  <h2>Verificação de Peso (Início de Turno)</h2>
  <div class="highlight">⚠️ <strong>Pendente:</strong> Aguarda registo de peso pelo operador (1 peça + 10 peças) no início do turno.</div>
</div>`}

<div class="footer">
  EP3D MES — Gerado em ${now} • Documento técnico de produção
</div>

<script>
  // Auto print after load
  // window.addEventListener('load', () => setTimeout(() => window.print(), 400));
</script>
</body>
</html>`;

  const w = window.open("", "_blank", "width=900,height=1000");
  if (!w) {
    alert("Bloqueado pelo browser. Permita pop-ups para imprimir.");
    return;
  }
  w.document.write(html);
  w.document.close();
}
